import {
  Component,
  inject,
  input,
  InputSignal,
  TemplateRef,
} from '@angular/core';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { ToFontSizePipe } from '../../../../pipes/to-font-size/to-font-size.pipe';
import { EFooterBlockType, ERelationType, IFooterBlock } from '@web/dtos';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { FilterTextsPipe } from '../../../../pipes/filterTexts/filterTexts.pipe';
import { FooterStore } from '../../../../services/api/footer/footer-store.service';
import { QuillViewComponent } from 'ngx-quill';

@Component({
  selector: 'aw-footer-block',
  imports: [
    CommonModule,
    NgTemplateOutlet,
    ToFontSizePipe,
    LanguagePipe,
    FilterTextsPipe,
    QuillViewComponent,
  ],
  templateUrl: './footer-block.component.html',
})
export class FooterBlockComponent {
  public readonly name: InputSignal<string | undefined> = input<string>();
  public readonly headline: InputSignal<string | undefined> = input<string>();
  public readonly headlineSize: InputSignal<number | undefined> =
    input<number>();
  public readonly showHeadline: InputSignal<boolean> = input<boolean>(true);
  public readonly children: InputSignal<TemplateRef<unknown> | undefined> =
    input<TemplateRef<unknown>>();
  public readonly block: InputSignal<IFooterBlock | undefined> =
    input<IFooterBlock>();
  protected readonly footerStore: FooterStore = inject(FooterStore);
  protected readonly FooterBlockType = EFooterBlockType;
  protected readonly RelationType = ERelationType;
}
